/**
 * 言語(ja/en)の正本。URL は `/en/` プレフィックス + 日本語 URL と同形(docs/_prompts/20260917_en_site_spec.md §0)。
 * 先例: D:/AI/site-thebutler/src/i18n/languages.ts(pathToLang / stripLangPrefix / withLangPrefix)。
 * react/DOM 非依存(SSG でも window を参照しない)。判定は必ず pathname(useLocation)から行う。
 */
export type Lang = 'ja' | 'en'

export const EN_PREFIX = '/en'

/** pathname から言語を判定する。`/en` または `/en/...` = en、それ以外 = ja(`/enterprise/` は ja)。 */
export function getLang(pathname: string): Lang {
  return pathname === EN_PREFIX || pathname.startsWith(`${EN_PREFIX}/`) ? 'en' : 'ja'
}

/** `/en/salon/` → `/salon/`、`/en/` → `/`、`/en` → `/`。EN でない URL は不変。 */
export function stripEn(url: string): string {
  if (url === EN_PREFIX) return '/'
  if (url.startsWith(`${EN_PREFIX}/`)) return url.slice(EN_PREFIX.length) || '/'
  return url
}

/** JA 相当の URL を指定言語の URL にする。`withLang('/salon/', 'en')` → `/en/salon/`、`withLang('/', 'en')` → `/en/`。 */
export function withLang(url: string, lang: Lang): string {
  const base = stripEn(url)
  if (lang === 'ja') return base
  if (!base.startsWith('/') || base.startsWith('/img/') || base.startsWith('//')) return base
  return base === '/' ? `${EN_PREFIX}/` : `${EN_PREFIX}${base}`
}

/** hreflang / html lang / og:locale の値 */
export const langMeta: Record<Lang, { hreflang: string; ogLocale: string }> = {
  ja: { hreflang: 'ja', ogLocale: 'ja_JP' },
  en: { hreflang: 'en', ogLocale: 'en_GB' },
}
